<fab-loading-spinner color="primary" *ngIf="showSpinner"
                     id="loading-spinner"></fab-loading-spinner>
<div id="header-container">
  <div>
    <h1 id="header-text">Delete Vehicle Detail Records</h1>
  </div>
  <div>
    <button mat-flat-button color="primary" id="report-button" class="action-button"
            (click)="getVehicleRecords()">
      Get Vehicle Records
    </button>
  </div>
</div>
<div class="drag-and-drop-container">
  <h4>
    <span class="template-dropzone-label">Please Select File to select worksheets from. </span> (Required
    Format: .xls or .xlsx)
  </h4>
</div>
<div (files)="upload($event)" appDrag class="dropzone">
  <div class="text-wrapper">
    <div class="centered">Drag and Drop Files Here</div>
    <p class="centered">or</p>
    <div>
      <app-upload-button (eventEmitter)="upload($event)" [apiUrl]="excelService.excelSheetUrl"
                         class="upload centered app-upload-button">
      </app-upload-button>
    </div>
  </div>
</div>
